import { addNamespace } from '@Utils/actions';
import { createAction } from '@reduxjs/toolkit';
import type { Status } from '@innovyze/lib-am-common';
import { GroupSet } from '@Types/groupSets.types';

export const listGroupSets = createAction(addNamespace('groupSets/list'));

export const listGroupSetsResolved = createAction<GroupSet[]>(
  addNamespace('groupSets/list/resolved')
);

export const listGroupSetsRejected = createAction<Status>(
  addNamespace('groupSets/list/rejected')
);
